import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import Ratio from 'react-ratio';
import { makeStyles } from '@material-ui/core/styles';

const playButtonStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginLeft: -44,
  marginTop: -44,
  color: '#ffffff',
  zIndex: 10000,
};

const messageStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    marginTop: '-1em',
    top: '50%',
    left: '0',
    color: '#ffffff',
    zIndex: 1000,
    textAlign: 'center',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      marginTop: '-1em',
    }
  }
}));

const buttonStyles = {
  position: 'absolute',
  top: 3,
  left: 3,
  zIndex: 10002,
  color: '#ffffff',
}

const streamStyles = {
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundColor: '#000',
  maxWidth: '100%',
};

const NotAvailableMessage = (props) => {
  const classes = messageStyles(props);
  return (<div className={classes.root}>Live stream will resume shortly</div> );
}

export default class RemoteVideo extends React.Component  {

  constructor(props) {
    super(props);
    this.state = { playing: false, prePlay: false };
    this.divRef = React.createRef();
    this.play = this.play.bind(this);
  }

  prePlay() {
    if( ! this.state.prePlay ) {
      console.log("### Stream prePlay handler (muted)");
      this.props.stream.play('remote_stream', {muted: true});
      this.props.stream.on("player-status-change", this.onStatusChange.bind(this) );
      this.setState({prePlay: true});
    }
  }

  play() {
    console.log("### Stream Play handler (with sound)");
    if( !this.state.playing ) {
      if( this.props.stream.isPlaying ) this.props.stream.stop();
      this.props.stream.play('remote_stream', {muted: false});
      this.setState({playing: true});
      // BAD - DOM
      try {
        document.getElementsByTagName("video")[0].controls = true;
        const video = document.querySelector('video');
        video.addEventListener('suspend', (event) => {
          console.log('### Data loading has been suspended.', event);
          video.play();
        });
      }catch(ex) {
        console.log("ex", ex);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if( (!prevProps.stream)&&(this.props.stream) ) { // got the stream
      this.prePlay();
    }
    if( (prevProps.stream)&&(!this.props.stream) ) { // lost the stream
      console.log("#### LOST STREAM ####");
      this.setState({playing: false});
      this.setState({prePlay: false});
      prevProps.stream.stop('remote_stream');
      if( prevProps.stream.isPlaying ) {
        //    prevProps.stream.stop('remote_stream');
      }
    }
  }

  onStatusChange(evt) {
    console.log("### Player status change",evt);
    if( evt.status == 'paused' ) {
      this.setState({playing: false});
    }
  }

  componentWillUnmount() {
    if( this.props.stream ) {
      this.props.stream.stop('remote_stream');
    }
    this.setState({ playing: false, eventSet: false });
  }

  componentDidMount() {
    if(this.props.stream) {
      this.prePlay();
    }
  }

  render() {
    let stream = this.props.stream;
    const playClick = () => {
      this.play();
    }
    return (
      <>
      <Ratio ratio={ 16 / 9 }>
        <div id="remote_stream" style={streamStyles} onClick={playClick}  >
          { ! this.props.stream ? <NotAvailableMessage /> : '' }
          { ((!this.props.stream) || this.state.playing) ? <></> : (<Button style={buttonStyles} onClick={playClick}>Click to play</Button>) }
        { ((!this.props.stream) || this.state.playing) ? <></> :
          (<IconButton aria-label="play" onClick={playClick} style={playButtonStyles} >
            <PlayCircleFilledIcon style={{width: 64, height: 64}} />
          </IconButton>) }
        </div>
      </Ratio>
      </>);
  }
}
